<app-crear-form-medico
  [response]="response"
  [editar]="editar"
></app-crear-form-medico>
